export default "__VITE_ASSET__CVl_j_Zq__"